module.exports = __webpack_public_path__ + "static/media/invoice.ca1e62de.jpg";